import $ from "jquery";

function goToAction(action) {
    let $el = $(`[data-rating-action="${action}"]`);
    if ($el.length) {
        $('a[href="#tab-ratings"]').tab('show');
        $(".pxa-accordion").find(".active").removeClass("active");
        $("#accordion-ratings").addClass("active");
        
        $("html, body").animate({
            scrollTop: $el.filter(":visible").offset().top,
        }, 250, "swing");
    }
}

export default function ratingActions() {
    function ratingActionListener(e) {
        e.preventDefault();
        e.stopPropagation();
        
        const action = $(this).attr("href").substr(1);
        
        if (history && history.pushState) {
            history.pushState(null, null, location.href.split("#")[0] + "#" + action);
        }
        
        goToAction(action);
    }
    
    (window.registerRatingActions = function () {
        $(".rating-actions a")
            .off("click", ratingActionListener)
            .on("click", ratingActionListener);
    })();
    
    if (location.hash.length > 1) {
        goToAction(location.hash.substr(1));
    }
}
